import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import ConfettiCanvas from 'react-confetti-canvas';
import makeModal from 'components/Modals';
import { CrossFade } from 'components/Transitions';
import Modals from 'modules/Modals';
import User from 'modules/User';
import Bingo from 'modules/Bingo';
import jackpotMessage from './lib/jackpotMessage';
import CalledBalls from './CalledBalls';
import Winner from './Winner';

const colors = [
  ['#F1948A', '#C39BD3'],
  ['#7FB3D5', '#76D7C4'],
  ['#F0B27A', '#7DCEA0']
];

const OneLineModal = makeModal(
  'oneLineWinner',
  { name: 'modal-slideEdgeFrom-right', timeout: 200 },
  {
    expiration: 5000,
    pinned: true,
    blocking: false,
    className: 'overflow-wrap overflow-wrap--modal'
  }
)(Winner);

const TwoLinesModal = makeModal(
  'twoLinesWinner',
  { name: 'modal-slideEdgeFrom-right', timeout: 200 },
  {
    expiration: 5000,
    pinned: true,
    blocking: false,
    className: 'overflow-wrap overflow-wrap--modal'
  }
)(Winner);

const GameWinModal = makeModal(
  'gameWinner',
  { name: 'modal-fade-long', timeout: 400 },
  { expiration: 6000, pinned: true, blocking: false }
)(Winner);

const ProgressiveWinModal = makeModal(
  'progressiveWinner',
  { name: 'modal-fade-long', timeout: 400 },
  { expiration: 6000, pinned: true, blocking: false }
)(Winner);

const RolloverModal = makeModal(
  'rollover',
  { name: 'modal-fade-long', timeout: 400 },
  { expiration: 6000, pinned: true, blocking: false }
)(Winner);

export class _BingoModals extends Component {
  constructor(props, context) {
    super(props, context);
    this.prevAmount = {};
    this.confettiTimeout = null;
    this.state = {
      gameWinners: props.gameWinners,
      progressiveGameWinners: props.progressiveGameWinners,
      rolloverEnd: props.progressiveJackpotAmount,
      showConfetti: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      username,
      oneLineWinners,
      twoLinesWinners,
      gameWinners,
      showWinner,
      rolloverEnd,
      progressiveGameWinners
    } = this.props;
    if (
      oneLineWinners.result !== nextProps.oneLineWinners.result &&
      !isEmpty(nextProps.oneLineWinners.result)
    ) {
      showWinner({ oneLine: true });
    }
    if (
      twoLinesWinners.result !== nextProps.twoLinesWinners.result &&
      !isEmpty(nextProps.twoLinesWinners.result)
    ) {
      showWinner({ twoLines: true });
    }
    if (
      gameWinners.result !== nextProps.gameWinners.result &&
      !isEmpty(nextProps.gameWinners.result)
    ) {
      showWinner({ game: true });
    }
    if (
      progressiveGameWinners.result !== nextProps.progressiveGameWinners.result &&
      !isEmpty(nextProps.progressiveGameWinners.result)
    ) {
      showWinner({ progressive: true });
    }
    if (rolloverEnd !== nextProps.rolloverEnd && nextProps.rolloverEnd) {
      showWinner({ rollover: true });
    }
    // Cache winners
    if (
      !isEmpty(nextProps.gameWinners.result) &&
      !isEmpty(nextProps.progressiveGameWinners.result)
    ) {
      const showConfetti =
        nextProps.gameWinners.entities[username] ||
        nextProps.progressiveGameWinners.entities[username];

      this.setState({
        showConfetti,
        gameWinners: nextProps.gameWinners,
        progressiveGameWinners: nextProps.progressiveGameWinners
      });
      this.resetConfetti();
    } else if (!isEmpty(nextProps.gameWinners.result)) {
      const showConfetti = nextProps.gameWinners.entities[username];

      this.setState({
        showConfetti,
        gameWinners: nextProps.gameWinners
      });
      this.resetConfetti();
    } else if (!isEmpty(nextProps.progressiveGameWinners.result)) {
      const showConfetti = nextProps.progressiveGameWinners.entities[username];

      this.setState({
        showConfetti,
        progressiveGameWinners: nextProps.progressiveGameWinners
      });
      this.resetConfetti();
    } else if (rolloverEnd) {
      this.setState({
        showConfetti: false,
        rolloverEnd: this.props.progressiveJackpotAmount
      });
      clearTimeout(this.confettiTimeout);
    }
  }

  componentWillUnmount() {
    this.props.hideWinners();
    clearTimeout(this.confettiTimeout);
  }

  getAmount = (winners) => {
    if (isEmpty(winners)) {
      return 0;
    } else {
      return (winners.entities && winners.entities[this.props.username]) || winners.amount;
    }
  };

  resetConfetti = () => {
    this.confettiTimeout = setTimeout(() => this.setState({ showConfetti: false }), 10000);
  };

  render() {
    const { refName, username, type, oneLineWinners, twoLinesWinners, logoImageUrl } = this.props;
    const { gameWinners, progressiveGameWinners, showConfetti, rolloverEnd } = this.state;
    return (
      <div className="modalContainer modalContainer--bingo">
        <CrossFade childKey={showConfetti ? 'confetti' : 'null'} className="confetti-wrap">
          {showConfetti ? <ConfettiCanvas colors={colors} /> : null}
        </CrossFade>
        <CalledBalls refName={refName} type={type} />
        {type === Bingo.constants.GAME_TYPE['90'] ? (
          <OneLineModal
            jackpotAmount={this.getAmount(oneLineWinners)}
            jackpotTitle="1 LINE WIN!"
            line
            userMessage={jackpotMessage(oneLineWinners.result, username)}
          />
        ) : null}
        {type === Bingo.constants.GAME_TYPE['90'] ? (
          <TwoLinesModal
            jackpotAmount={this.getAmount(twoLinesWinners)}
            jackpotTitle="2 LINES WIN!"
            line
            userMessage={jackpotMessage(twoLinesWinners.result, username)}
          />
        ) : null}
        <GameWinModal
          jackpotAmount={this.getAmount(gameWinners)}
          jackpotTitle="FULL HOUSE WIN!"
          userMessage={jackpotMessage(gameWinners.result, username)}
          noTrophy={!gameWinners?.entities?.[username]}
        />
        <ProgressiveWinModal
          jackpotAmount={this.getAmount(progressiveGameWinners)}
          jackpotTitle="PROGRESSIVE JACKPOT!"
          userMessage={jackpotMessage(progressiveGameWinners.result, username)}
        />
        <RolloverModal
          jackpotAmount={rolloverEnd}
          image={logoImageUrl}
          jackpotTitle="Jackpot rollover!"
          userMessage="Try your luck next time with a bigger jackpot"
          noTrophy
        />
      </div>
    );
  }
}

_BingoModals.propTypes = {
  username: PropTypes.string,
  type: PropTypes.oneOf(['30', '75', '90']),
  showWinner: PropTypes.func,
  logoImageUrl: PropTypes.string,
  rolloverEnd: PropTypes.bool,
  oneLineWinners: PropTypes.object,
  twoLinesWinners: PropTypes.object,
  gameWinners: PropTypes.object,
  progressiveGameWinners: PropTypes.object
};

_BingoModals.defaultProps = {
  username: '',
  logoImageUrl: undefined,
  type: '75',
  rolloverEnd: false,
  showWinner: null,
  oneLineWinners: {},
  twoLinesWinners: {},
  gameWinners: {},
  progressiveGameWinners: {}
};

const mapStateToProps = (state) => {
  const refName = Bingo.selectors.getActiveRef(state);
  const roomProps = Bingo.selectors.getDisplayProps(state) || {};
  const username = User.selectors.model(state).username;
  const { type, logoImageUrl } = roomProps;
  const rolloverEnd = Bingo.selectors.getRolloverEnd(state, refName, 'current');
  const oneLineWinners = Bingo.selectors.getOneLineWinners(state, refName, 'current');
  const twoLinesWinners = Bingo.selectors.getTwoLinesWinners(state, refName, 'current');
  const gameWinners = Bingo.selectors.getGameWinners(state, refName, 'current');
  const progressiveGameWinners = Bingo.selectors.getProgressiveGameWinners(
    state,
    refName,
    'current'
  );
  // Only use with rollover
  const progressiveJackpotAmount = Bingo.selectors.getProgressiveJackpotAmount(
    state,
    refName,
    'current'
  );

  return {
    refName,
    username,
    oneLineWinners,
    twoLinesWinners,
    gameWinners,
    progressiveGameWinners,
    progressiveJackpotAmount,
    rolloverEnd,
    logoImageUrl,
    type
  };
};

const mapDispatchToProps = (dispatch) => ({
  showWinner: ({
    oneLine = false,
    twoLines = false,
    game = false,
    progressive = false,
    rollover = false
  }) => {
    if (oneLine) {
      dispatch(Modals.actions.open('oneLineWinner'));
    }
    if (twoLines) {
      dispatch(Modals.actions.open('twoLinesWinner'));
    }
    if (game) {
      dispatch(Modals.actions.open('gameWinner'));
    }
    if (progressive) {
      dispatch(Modals.actions.open('progressiveWinner'));
    }
    if (rollover) {
      dispatch(Modals.actions.open('rollover'));
    }
  },
  hideWinners: () => {
    dispatch(Modals.actions.close('oneLineWinner'));
    dispatch(Modals.actions.close('twoLinesWinner'));
    dispatch(Modals.actions.close('gameWinner'));
    dispatch(Modals.actions.close('progressiveWinner'));
    dispatch(Modals.actions.close('rollover'));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(_BingoModals);
